/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useMantineColorScheme } from '@mantine/core';
import { Plus, X } from 'tabler-icons-react';
import { assetPrefix } from '../../../utilities/general';
import FilterContainer from './FilterContainer';
import { filterConfigDemo } from '../../../utilities/filterConfigs';
import AppliedFiltersSummary from './AppliedFiltersSummary';

const FilterExpansionComponent = ({
  currentTab, data, setData, originalData, setIsFilterActive,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [resetTrigger, setResetTrigger] = useState(0);

  const coldWalletUrl = window.location.href;

  const matchColdWalletUrl = coldWalletUrl.includes('cold-wallet');

  const { colorScheme } = useMantineColorScheme();

  const hasActiveFilters = Object.values(appliedFilters).some(
    (filter) => (Array.isArray(filter) ? filter.length > 0 : !!filter),
  );
  useEffect(() => {
    setIsFilterActive(hasActiveFilters);
  }, [hasActiveFilters]);

  const handleClearFilters = () => {
    setAppliedFilters({});
    setData(originalData);
    setResetTrigger((prev) => prev + 1);
  };

  return (
    <div className={`flex items-center justify-between ${matchColdWalletUrl && 'rounded-t-md dark:!bg-[#26282C]'} border-b ${colorScheme === 'dark' ? 'border-neutral-500 bg-[#1a1b1e]' : 'border-gray-200 bg-[#F8FAFC]'} border-solid ml-0 px-4 py-4`}>
      <div className="flex items-center gap-2">
        <img src={`${assetPrefix}/images/filterLogo.svg`} alt="filterLogo" />
        <AppliedFiltersSummary
          appliedFilters={appliedFilters}
          filterConfig={filterConfigDemo}
          currentTab={currentTab}
          showAllFilters={false}
          onClick={() => setIsModalOpen(true)}
        />
        <div onClick={() => setIsModalOpen(true)} className={`flex items-center gap-1 ${colorScheme === 'dark' ? 'bg-[#1A2E3B] text-[#4FC3F7]' : 'bg-[#E7F6FF] text-[#0093EF]'} px-2 py-1 font-semibold text-sm rounded-md cursor-pointer`}>
          <Plus
            size={14}
            strokeWidth={3}
            color="#0093EF"
          />
          Add Filter
        </div>
        {hasActiveFilters && (
          <div
            className={`flex items-center justify-center gap-1 ${colorScheme === 'dark' ? 'bg-[#243E60] text-gray-200' : 'bg-gray-200 text-gray-500'}  px-2 py-1 font-semibold text-sm rounded-md cursor-pointer`}
            onClick={handleClearFilters}
          >
            <X size={12} strokeWidth={3} />
            Clear All
          </div>
        )}
      </div>
      <FilterContainer
        currentTab={currentTab}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        originalData={originalData}
        data={data}
        setData={setData}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        handleClear={handleClearFilters}
        resetTrigger={resetTrigger}
      />
      <div className={`text-sm mr-6 font-semibold ${colorScheme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
        {data ? `${data?.length} Records` : ''}
      </div>
    </div>
  );
};

export default FilterExpansionComponent;
